import request from "@/utils/request";

/** 平台红点数据（平台用户调用） */
export interface PlatformRedDotData {
  /** 待审商户数量 */
  operatorApplyPendingCount: number;
  /** 审核中心待审数量 */
  reviewPendingCount: number;
  [property: string]: any;
}

/** 商户红点数据（商户用户调用） */
export interface MerchantRedDotData {
  /** 商户申请未读数量 */
  operatorApplyCount: number;
  [property: string]: any;
}

/** 获取平台红点数据 GET /api/v1/sys/getPlatformRedDot（仅平台用户调用） */
export async function getPlatformRedDot() {
  return request<PlatformRedDotData>("/api/v1/sys/getPlatformRedDot", {
    method: "GET",
  });
}

/** 获取商户红点数据 GET /api/v1/sys/getMerchantRedDot（仅商户用户调用） */
export async function getMerchantRedDot() {
  return request<MerchantRedDotData>("/api/v1/sys/getMerchantRedDot", {
    method: "GET",
  });
}

/** 消除商户红点 POST /api/v1/sys/dismissMerchantRedDot */
export async function dismissMerchantRedDot() {
  return request("/api/v1/sys/dismissMerchantRedDot", {
    method: "POST",
  });
}
